/**
 * transform object into queries path
 * */
export const stringifyQueryObject = (queries) => {
  return (
    (Object.keys(queries).length ? '?' : '') +
    Object.keys(queries)
      .map((key) => (queries[key] !== '' ? `${key}=${queries[key]}` : ''))
      .join('&')
  );
};
